var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-cell"},[_c('a',{attrs:{"id":`gridProjectId${_vm.data.projectId}`,"href":_vm.viewProject,"target":"_parent _blank"}},[_vm._v(" "+_vm._s(_vm.data.projectId)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }